import { CheckCircle2, XCircle } from "lucide-react";
import { PlanStatusBadge } from "@/components/ai/PlanStatusBadge";
import { PlanChangeSummaryList } from "@/components/ai/PlanChangeSummaryList";

/**
 * v1.3 Wave 2 — appended into the chat thread right after a plan is
 * approved & executed. Reflects only what ACTUALLY happened
 * (`plan.execution_result`), never what was merely proposed — per-lesson
 * results are shown individually so a partial success (some lessons
 * skipped due to a late conflict) is never hidden.
 */
export const ActionPlanCompletionCard = ({ plan }) => {
  const result = plan.execution_result || {};
  const perLesson = result.per_lesson_results || [];
  const summaryCounts = Object.fromEntries(
    Object.entries(result).filter(([key, value]) => key !== "per_lesson_results" && typeof value !== "object")
  );

  return (
    <div className="rounded-xl border bg-card" data-testid="ai-action-plan-completion-card" data-plan-id={plan.id}>
      <div className="p-3">
        <div className="flex items-start justify-between gap-3">
          <h4 className="font-heading text-base font-semibold">{plan.title} &mdash; completed</h4>
          <PlanStatusBadge status="executed" />
        </div>
        <p className="mt-1 text-xs text-muted-foreground">Here&apos;s exactly what was applied.</p>

        {Object.keys(summaryCounts).length > 0 && (
          <div className="mt-3">
            <PlanChangeSummaryList counts={summaryCounts} testIdPrefix="ai-action-plan-completion-metric" />
          </div>
        )}

        {perLesson.length > 0 && (
          <div className="mt-3 space-y-2" data-testid="ai-action-plan-completion-view-details-button">
            {perLesson.map((item, idx) => (
              <div key={item.appointment_id || idx} className="flex items-start justify-between gap-3 rounded-lg border bg-background/40 p-2">
                <div className="flex items-start gap-2">
                  {item.applied ? (
                    <CheckCircle2 className="h-3.5 w-3.5 mt-0.5 shrink-0 text-[hsl(var(--ai-executed))]" />
                  ) : (
                    <XCircle className="h-3.5 w-3.5 mt-0.5 shrink-0 text-[hsl(var(--ai-risk))]" />
                  )}
                  <div>
                    <p className="text-xs font-medium text-foreground">{item.student_name}</p>
                    <p className="text-xs text-muted-foreground">{item.detail}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
